import PropTypes from "prop-types";
import "./Checkbox.css";

export default function Checkbox({
  label,
  value,
  id,
  name,
  checked,
  onChange,
  disabled,
}) {
  return (
    <label>
      <input
        type="checkbox"
        value={value}
        id={id}
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      {label}
    </label>
  );
}

Checkbox.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  id: PropTypes.string,
  name: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
